import { Button } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../Helpers/Logo";

const UserNotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
      <div
        className="card shadow border-0"
        style={{ width: "375px", height: "812px" }}
      >
        <div className="card-body d-flex flex-column justify-content-center align-items-center text-center p-4">
          <Logo />
          <h2 className="text-dark fw-bold mb-3" style={{ fontSize: "1.5rem" }}>
            User Not Found
          </h2>
          <p className="text-muted mb-4" style={{ fontSize: "0.9rem" }}>
            We couldn't locate the user you're searching for. Please check the
            username or try again later.
          </p>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/")}
            style={{
              textTransform: "none",
              fontSize: "14px",
              padding: "10px 20px",
              borderRadius: "8px",
              backgroundColor: "#007bff", // Bootstrap primary color
            }}
            className="shadow"
          >
            Go Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UserNotFound;
